export enum NegotiationType {
  ON_SPOT,
  NEXT_DAY
}

export const NegotiationTypeText: { [key in NegotiationType]: string } = {
  [NegotiationType.ON_SPOT]: 'On spot',
  [NegotiationType.NEXT_DAY]: 'Next day'
}
